<!-- 【前台首页】 -->
<template>
  <div class="front-body">
    <el-card class="box-card" style="min-height: 800px">
    <div slot="header" class="clearfix">
      <sui-breadcrumb></sui-breadcrumb>
    </div>
      <el-card id="software" class="box-card" style="padding-bottom: 10px">
        <div slot="header" class="clearfix">
          <span>软件下载</span>
        </div>
        <sui-card v-for="item in dataList" :key="item.id"
                  :title="item.title"
                  :imgsrc="item.picture"
                  :href="item.href"
                  :content="item.content">
        </sui-card>
      </el-card>
      <el-card v-for="(item,index) in itemList" :key="item.id" class="box-card">
        <div slot="header" class="clearfix">
          <span>{{index+1}}、{{item.title}}</span>
        </div>
        <div v-html="item.content"></div>
      </el-card>
    </el-card>
    <el-backtop target=".front-page" :bottom="100" :visibility-height="50"></el-backtop>
  </div>
</template>

<script>
  import {MessageBox} from "element-ui";

  export default {
    data() {
      return {
        dataList: [],
        itemList: [],
        total:0,
        queryForm: {
          current: 1,
          size: 8,
          id: "",
          picture: "",
          title: "",
          name: "",
          categoryId: "",
          content: ""
        },
      }
    },
    computed: {},
    mounted(){
      //初始化数据
      this.getList();
    },
    methods: {
      //点击搜索
      handleQuery() {
        this.queryForm.current = 1;
        this.getList();
      },
      //查询列表数据
      getList() {
        const loading = this.$loading({
          lock: true,
          text: '请稍后,加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0,0,0,0.25)'
        });
        this.$request.doGet('/api/item/getPage?itemType=2').then(res => {
          if (res.isOk) {
            this.dataList = res.obj.records;
            loading.close();
          }
        });
        this.$request.doGet('/api/item/getPage?itemType=3').then(res => {
          if (res.isOk) {
            this.itemList = res.obj.records;
          }
        });
      },
      //重置查询
      resetQuery() {
        this.$refs['queryForm'].resetFields();
        this.handleQuery();
      },
      //选择页码
      handleCurrentChange: function (currentPage) {
        this.queryForm.current = currentPage;
        this.getList();
      },
    }
  }
</script>
<style scoped>
  .search {
    padding-top: 50px;
    border-radius: 5px;
    text-align: center;
    background: white;
    height: 150px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
  }

  .search-btn {
    width: 500px
  }

  .category {
    padding: 10px
  }

  .category-link {
    padding: 5px 20px
  }
</style>




// WEBPACK FOOTER //
// src/pages/front/service/item/software.vue